import { RouteReuseStrategy } from '@angular/router';

export class RouteStrategy extends RouteReuseStrategy {
    shouldDetach(): boolean {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    store(): void {

    }
    shouldAttach(): boolean {
        return false;
    }
    retrieve(): unknown {
        return null;
    }
    shouldReuseRoute(): boolean {
        return false; // default is true if configuration of current and future route are the same
    }
}
